module.exports = __webpack_public_path__ + "img/OV_Stab.1a6449ab.svg";